import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function JobSeekerDashboard() {
  return (

        <div className="content-body">

            <div className="container-fluid mt-3">
                <section className="container my-5">
  <div className="text-center mb-4">
    <h2>Recommended Jobs for You</h2>
    <p>Explore our curated list of job openings that match your profile.</p>
  </div>
  <div className="row">
   
    <div className="col-md-6 col-lg-4 mb-4">
      <a href="#" className="card shadow-sm text-decoration-none text-dark">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="badge bg-primary">Design</span>
            <small className="text-muted"><i className="fas fa-clock me-1"></i> Full-time</small>
          </div>
          <h5 className="card-title">Senior Graphic Designer</h5>
          <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> New York, US</p>
          <div className="text-end text-muted">
            <small><i className="fas fa-chevron-right"></i></small>
          </div>
        </div>
      </a>
    </div>

   
    <div className="col-md-6 col-lg-4 mb-4">
      <a href="#" className="card shadow-sm text-decoration-none text-dark">
        <div className="card-body">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <span className="badge bg-success">Development</span>
            <small className="text-muted"><i className="fas fa-clock me-1"></i> Part-time</small>
          </div>
          <h5 className="card-title">Front End Developer</h5>
          <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> Remote</p>
          <div className="text-end text-muted">
            <small><i className="fas fa-chevron-right"></i></small>
          </div>
        </div>
      </a>
    </div>


<div className="col-md-6 col-lg-4 mb-4">
  <a href="#" className="card shadow-sm text-decoration-none text-dark">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="badge bg-warning text-dark">Marketing</span>
        <small className="text-muted"><i className="fas fa-clock me-1"></i> Full-time</small>
      </div>
      <h5 className="card-title">Digital Marketing Specialist</h5>
      <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> San Francisco, CA</p>
      <div className="text-end text-muted">
        <small><i className="fas fa-chevron-right"></i></small>
      </div>
    </div>
  </a>
</div>

<div className="col-md-6 col-lg-4 mb-4">
  <a href="#" className="card shadow-sm text-decoration-none text-dark">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="badge bg-info text-dark">Customer Service</span>
        <small className="text-muted"><i className="fas fa-clock me-1"></i> Contract</small>
      </div>
      <h5 className="card-title">Customer Support Representative</h5>
      <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> Austin, TX</p>
      <div className="text-end text-muted">
        <small><i className="fas fa-chevron-right"></i></small>
      </div>
    </div>
  </a>
</div>

<div className="col-md-6 col-lg-4 mb-4">
  <a href="#" className="card shadow-sm text-decoration-none text-dark">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="badge bg-danger">Finance</span>
        <small className="text-muted"><i className="fas fa-clock me-1"></i> Internship</small>
      </div>
      <h5 className="card-title">Financial Analyst Intern</h5>
      <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> Chicago, IL</p>
      <div className="text-end text-muted">
        <small><i className="fas fa-chevron-right"></i></small>
      </div>
    </div>
  </a>
</div>

<div className="col-md-6 col-lg-4 mb-4">
  <a href="#" className="card shadow-sm text-decoration-none text-dark">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="badge bg-secondary">Human Resources</span>
        <small className="text-muted"><i className="fas fa-clock me-1"></i> Full-time</small>
      </div>
      <h5 className="card-title">HR Manager</h5>
      <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> Boston, MA</p>
      <div className="text-end text-muted">
        <small><i className="fas fa-chevron-right"></i></small>
      </div>
    </div>
  </a>
</div>

<div className="col-md-6 col-lg-4 mb-4">
  <a href="#" className="card shadow-sm text-decoration-none text-dark">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <span className="badge bg-success">Engineering</span>
        <small className="text-muted"><i className="fas fa-clock me-1"></i> Full-time</small>
      </div>
      <h5 className="card-title">Mechanical Engineer</h5>
      <p className="card-text"><i className="fas fa-map-marker-alt me-1"></i> Seattle, WA</p>
      <div className="text-end text-muted">
        <small><i className="fas fa-chevron-right"></i></small>
      </div>
    </div>
  </a>
</div>

   
  </div>
</section>

            </div>
           
        </div>
      
  );
}

export default JobSeekerDashboard;
